<script>
export default {
  name: 'DesktopMoveCombined',
  beforeRouteEnter(to, from, next) {
    next({ name: 'disclaimer', query: from.query });
  },
};
</script>
